let headerHeight = document.getElementById("header").offsetHeight;
let supElements = document.querySelectorAll("sup");
let disclaimerElements = document.querySelectorAll(".disclaimer");

supElements.forEach(function (supElement) {
  if (!isNaN(supElement.textContent)) {
    supElement.classList.add("hover-pointer");
    supElement.addEventListener("click", function () {
      let uniqueID = this.textContent;
      let disclaimerElement = document.getElementById("disclaimer-" + uniqueID);
      if (disclaimerElement) {
        let disclaimerSection = document.getElementById("disclaimer-section");

        // Save the current scroll position
        history.pushState({scrollY: window.scrollY}, '');

        let targetPosition = disclaimerSection.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scroll({ top: targetPosition, behavior: 'smooth' });

        // disclaimerSection.scrollIntoView({ behavior: "smooth", block: "center" });
        disclaimerElements.forEach(function (disclaimerElementSub) {
          disclaimerElementSub.classList.remove("has-purple-color", "has-text-color");
        });
        disclaimerElement.classList.add("has-purple-color", "has-text-color");
      }
    });
  }
});

// return to previous position on disclaimer click
disclaimerElements.forEach(function (disclaimerElement) {
  disclaimerElement.addEventListener("click", function() {
    if (history.state && history.state.scrollY !== undefined) {
      window.scrollTo(0, history.state.scrollY);
    }
  });
});

// Listen for when the user navigates the history entries
window.addEventListener('popstate', function(e) {
  if(e.state) {
    
    window.scrollTo(0, e.state.scrollY);
  }
});
